import { Person, prettyTitle } from "@/types";

export const fieldsFromPersons = (persons: ReadonlyArray<Person>, includeSomeoneElse: boolean) => {
  const fields = persons.map(({ id, title, firstName, lastName }) => {
    return { value: id, label: `${prettyTitle(title)} ${firstName} ${lastName}` };
  });

  if (!includeSomeoneElse) {
    return fields;
  }

  return fields.concat({
    value: "",
    label: "Someone else",
  });
};

export const defaultResponsible = (persons: ReadonlyArray<Person>) => {
  if (persons.length === 1) {
    return persons[0];
  }

  const responsiblePersons
    = persons.filter((person) => (person.roles || []).includes("responsible"));

  if (responsiblePersons
    .length === 1) {
    return responsiblePersons[0];
  }
};
